export default __webpack_public_path__ + "static/spark_app_add_account-7395cf4ed2b19c38c5323f5271bcbbd4.png";